export const iconFontAwesomeTravelHotelVanShuttle = (
	<i className="fa-solid fa-van-shuttle"></i>
);
